import { render, staticRenderFns } from "./Background.vue?vue&type=template&id=7913ff31&scoped=true&"
var script = {}
import style0 from "./Background.vue?vue&type=style&index=0&id=7913ff31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7913ff31",
  null
  
)

export default component.exports